/*
 * @Author: 吴攸
 * @Date: 2021-02-26 12:16:56
 * @LastEditTime: 2021-03-02 15:44:22
 * @LastEditors: 吴攸
 * @Description: 
 * @FilePath: /tracker-plugin-jserror/src/libs/sendLog.js
 */
import { getGlobal } from '../utils/global';
var UPLOAD_STACK_LIMIT = 2000;

function getShortUrl(url) {
  if (!url) {
    return '';
  }

  if (url.length < 1001) {
    return url;
  }

  return url.substr(0, 997) + '...';
}

function getLines(stack) {
  if (!stack || typeof stack !== 'string') {
    return '';
  }

  try {
    var stackLines = stack.split('\n') // 分行
    .slice(1) // 删除第一行：错误名称
    .map(function (stack) {
      return stack.replace(/^\s+at\s+/, '');
    }) // 去掉每一行堆栈的 at
    .filter(function (stack) {
      return !!stack;
    }); // 去除空行
    // 如果长度满足要求，直接上报

    if (stackLines.join('^').length <= UPLOAD_STACK_LIMIT) {
      return stackLines.join('^');
    } else {
      var hasIgnoredStack = false; // 记录是否忽略了某些堆栈

      while (stackLines.join('^').length > UPLOAD_STACK_LIMIT) {
        if (stackLines.length === 2) {
          // 行数为2，删除最后一行
          stackLines.splice(1, 1);
          hasIgnoredStack = true;
        } else if (stackLines.length === 1) {
          // 行数为1，忽略中间部分
          var firstLine = stackLines[0];
          stackLines[0] = "".concat(firstLine.substr(0, 997), "...").concat(firstLine.substr(-1000, 1000));
        } else {
          // 从倒数第二行开始删
          stackLines.splice(stackLines.length - 2);
          hasIgnoredStack = true;
        }
      } // 如果有堆栈被忽略了，用...在对应位置标记下


      if (stackLines.length > 1 && hasIgnoredStack) {
        var lastLine = stackLines.pop();
        return stackLines.join('^') + '^...^' + lastLine;
      } else if (stackLines.length === 1 && hasIgnoredStack) {
        return stackLines[0] + '^...';
      } else {
        return stackLines.join('^');
      }
    }
  } catch (e) {
    return '';
  }
}

function getErrorType(e) {
  if (typeof e.message === 'string') {
    var pattern = e.message.match(/Uncaught (\w+):/);
    if (pattern && pattern[1]) return pattern[1];
  }

  if (e.error_type) return e.error_type;else if (e.name) return e.name;else return e.constructor.name;
}

function sendLog(e) {
  if (typeof e !== 'object') return;
  var AES = getGlobal('AES');
  var _e$message = e.message,
      message = _e$message === void 0 ? '' : _e$message,
      url = e.filename,
      lineno = e.lineno,
      colno = e.colno,
      stack = e.stack,
      _e$error_code = e.error_code,
      error_code = _e$error_code === void 0 ? '' : _e$error_code,
      error = e.error;

  var _ref = AES.getConfig('plugin_jserror') || {},
      ignoreList = _ref.ignoreList;

  if (ignoreList) {
    if (ignoreList.some(function (rule) {
      if (typeof rule === 'string') {
        return rule === message;
      } else if (typeof rule === 'function') {
        try {
          return rule(message, e);
        } catch (ex) {}
      } else if (rule instanceof RegExp) {
        return rule.test(message);
      }
    })) {
      return;
    }
  }

  AES.log('js_error', {
    message: message,
    url: getShortUrl(url),
    lineno: lineno,
    colno: colno,
    stack: getLines(error && error.stack || stack),
    error_type: getErrorType(e),
    error_code: error_code
  });
}

export default sendLog;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-jserror@1.0.13@@ali/aes-tracker-plugin-jserror/es/libs/sendLog.js
// module id = null
// module chunks = 